// VOD03 / STORE03 progress reporting: every 15 s while playing, and on pause, seek completion, end and dispose.
// seq increases strictly per playback session so an older session can never overwrite a newer one.
import type { StateOperation } from '@tuned/contracts';

export const PROGRESS_INTERVAL_MS = 15_000;

export function trackProgress(
  video: HTMLVideoElement,
  ids: { itemId: string; sessionId: string },
  send: (op: StateOperation) => void,
) {
  let seq = 0;
  let timer: ReturnType<typeof setInterval> | undefined;
  const flush = () => {
    const pos = video.currentTime;
    if (!Number.isFinite(pos) || pos <= 0) return;
    const d = video.duration;
    send({ op: 'progress.update', itemId: ids.itemId, positionSec: pos, durationSec: Number.isFinite(d) ? d : null, sessionId: ids.sessionId, seq: ++seq });
  };
  const onPlaying = () => { timer ??= setInterval(flush, PROGRESS_INTERVAL_MS); };
  const onHalt = () => { clearInterval(timer); timer = undefined; flush(); };
  video.addEventListener('playing', onPlaying);
  video.addEventListener('pause', onHalt);
  video.addEventListener('ended', onHalt);
  video.addEventListener('seeked', flush);
  if (!video.paused) onPlaying();
  return {
    flush,
    /** Final flush, then stop listening. Call before the engine tears the media down. */
    dispose() {
      video.removeEventListener('playing', onPlaying);
      video.removeEventListener('pause', onHalt);
      video.removeEventListener('ended', onHalt);
      video.removeEventListener('seeked', flush);
      clearInterval(timer);
      flush();
    },
  };
}
